import { devtools } from 'zustand/middleware';

import { type WishlistItem } from '@app/client/resources/wishlists/types';
import { create } from '@app/store/zustand/helpers/create';

interface State {
    wishlistSlug?: string;
    wishlistItems: {
        tokenItems: WishlistItem[];
        collectionItems: WishlistItem[];
    };
}
interface Actions {
    setWishlistItems: ({
        wishlistSlug,
        wishlistItems,
    }: {
        wishlistSlug: string;
        wishlistItems: State['wishlistItems'];
    }) => void;
}
type WishlistPageStore = State & Actions;
const initialState: State = {
    wishlistSlug: undefined,
    wishlistItems: { tokenItems: [], collectionItems: [] },
};

export const STORE_KEY_WISHLIST_ITEMS = 'wishlist-items-store';
export const useWishlistItemStore = create<WishlistPageStore>()(
    devtools(
        (set) => ({
            ...initialState,
            setWishlistItems: ({ wishlistSlug, wishlistItems }) =>
                set((state) => {
                    const existingItems = state.wishlistItems;
                    const totalItems = existingItems || { tokenItems: [], collectionItems: [] };
                    for (const type in wishlistItems) {
                        let totalTypeItems = existingItems[type] || [];
                        for (const item of wishlistItems[type]) {
                            const found = existingItems?.[type]?.find((ei: WishlistItem) => ei?.id === item?.id);
                            if (!found) {
                                totalTypeItems = [...totalTypeItems, item];
                            }
                        }
                        totalItems[type] = totalTypeItems;
                    }

                    return { wishlistSlug, wishlistItems: totalItems };
                }),
        }),
        { name: STORE_KEY_WISHLIST_ITEMS },
    ),
);
